import React, { Component } from 'react'
import styles from './index.scss'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { imageUrl } from '@libs/appUrl'
import { compose, withTranslation } from '@hocs'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import { isMobile } from 'react-device-detect'
import CarouselButton from './CarouselButton'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import cx from 'classnames'

class CarouselImageList extends Component {
  _isSwiping = false

  static defaultProps = {
    renderCaption: () => null,
    onClickOpenImageModal: () => false,
  }

  constructor(props) {
    super(props)
    this.state = {
      firstLoad: true,
      isOpenImageModal: false,
      photoIndex: 0,
    }
  }

  componentDidUpdate(prevProps) {
    const { images } = this.props
    if (images && images[0] && images[0].path !== prevProps.images[0].path) {
      this._carouselMainEl.slickGoTo(0, false)
    }
  }

  _getImageArr = () => {
    const { images } = this.props
    return images.map((img) => {
      return imageUrl(img.path)
    })
  }

  render() {
    const { images } = this.props
    const { photoIndex } = this.state
    const imageArr = this._getImageArr()
    return (
      <div className="carouselImageList">
        <style jsx>{styles}</style>
        <div className={cx('mainImageOuter', { carouselHover: !isMobile })}>
          <Slider
            onReInit={this._onReInitCarousel}
            afterChange={this._afterChangeCarousel}
            onSwipe={this._onSwipeCarousel}
            arrows={!isMobile}
            lazyLoad={'progressive'}
            adaptiveHeight={false}
            initialSlide={0}
            slidesToShow={1}
            slidesToScroll={1}
            dots={false}
            infinite={false}
            ref={(el) => (this._carouselMainEl = el)}
            autoplay={false}
            prevArrow={
              <CarouselButton>
                <button>
                  <ArrowBackIosIcon className="icon-arrow-left1" />
                </button>
              </CarouselButton>
            }
            nextArrow={
              <CarouselButton>
                <button>
                  <ArrowForwardIosIcon className="icon-arrow-right1" />
                </button>
              </CarouselButton>
            }
          >
            {images.map((img, index) => {
              return (
                <div className="coverOuter" key={img.path} onClick={this._onClickOpenImageModal}>
                  <div
                    className="cover"
                    style={{ visibility: this.state.isOpenImageModal ? 'hidden' : 'visible' }}
                  >
                    <img src={imageUrl(img.path)} alt={img.fullname} />
                    {this.props.renderCaption(index)}
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
        {this.state.isOpenImageModal && (
          <Lightbox
            mainSrc={imageArr[photoIndex]}
            nextSrc={imageArr[(photoIndex + 1) % images.length]}
            prevSrc={imageArr[(photoIndex + imageArr.length - 1) % imageArr.length]}
            onCloseRequest={this._onCloseImageModal}
            onMovePrevRequest={this._onMovePrevRequest}
            onMoveNextRequest={this._onMoveNextRequest}
          />
        )}
      </div>
    )
  }

  _slickGoTo = () => {
    this._carouselMainEl.slickGoTo(this.state.photoIndex)
  }

  _onMoveNextRequest = () => {
    const { images } = this.props
    const { photoIndex } = this.state
    this.setState({ photoIndex: (photoIndex + 1) % images.length }, this._slickGoTo())
  }

  _onMovePrevRequest = () => {
    const { images } = this.props
    const { photoIndex } = this.state
    this.setState(
      { photoIndex: (photoIndex + images.length - 1) % images.length },
      this._slickGoTo(),
    )
  }

  _afterChangeCarousel = () => {
    this._isSwiping = false
  }

  _onReInitCarousel = () => {
    if (this._carouselMainEl && this.state.firstLoad) {
      this._carouselMainEl.slickGoTo(0, false)
      this.setState({ firstLoad: false })
    }
  }

  _onClickOpenImageModal = () => {
    if (this._isSwiping) return
    const { onClickOpenImageModal } = this.props
    this.setState({ isOpenImageModal: true }, () => {
      document.body.style.overflow = 'hidden'
      document.body.style.position = 'fixed'
      if (onClickOpenImageModal) onClickOpenImageModal()
    })
  }

  _onCloseImageModal = () => {
    this.setState({ isOpenImageModal: false }, () => {
      document.body.style.overflow = null
      document.body.style.position = null
    })
  }

  _onSwipeCarousel = () => {
    this._isSwiping = true
  }
}

export default compose(withTranslation())(CarouselImageList)
